import { render, staticRenderFns } from "./DeudaImport.vue?vue&type=template&id=0008adad&scoped=true"
import script from "./DeudaImport.vue?vue&type=script&lang=js"
export * from "./DeudaImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0008adad",
  null
  
)

export default component.exports